import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faStar } from '@fortawesome/free-solid-svg-icons';

import { formatScore } from './providerFormat';

const STARS = [0, 1, 2, 3, 4];

// Cinco estrelas com preenchimento proporcional (4,6 = quatro cheias e 60% da quinta).
export default function Stars({ value, showValue = true, size = 'sm' }) {
  const number = Math.min(5, Math.max(0, Number(value) || 0));
  return (
    <span className={`pv-stars pv-stars-${size}`}>
      <span className='pv-stars-track' role='img' aria-label={`Nota ${formatScore(number)} de 5`}>
        <span className='pv-stars-base' aria-hidden='true'>
          {STARS.map((i) => <FontAwesomeIcon key={i} icon={faStar} />)}
        </span>
        <span className='pv-stars-fill' style={{ width: `${(number / 5) * 100}%` }} aria-hidden='true'>
          {STARS.map((i) => <FontAwesomeIcon key={i} icon={faStar} />)}
        </span>
      </span>
      {showValue && <strong className='pv-stars-value'>{formatScore(number)}</strong>}
    </span>
  );
}
